import classNames from 'classnames';
import React from 'react';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import { BLUE, GOLD } from '@castandcrew/cnc-ui/theme/colors';

const styles = theme => ({
  root: {
    width: '300px',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridTemplateRows: '20px 1fr',
    padding: '0px 10px',
  },
  current: {
    borderLeft: `2px solid ${BLUE}`,
    color: BLUE,
  },
  previous: {
    borderLeft: `2px solid ${GOLD}`,
    color: GOLD,
  },
  status: {
    gridColumn: 1,
    gridRow: 1,
    fontStyle: 'italic',
  },
  timeStamp: {
    gridColumn: 2,
    gridRow: 1,
    fontStyle: 'italic',
  },
  content: {
    gridColumn: '1 / -1',
    gridRow: 2,
    whiteSpace: 'pre-line',
    color: 'rgb(84, 84, 84)',
  },
});

const SavedDealNote = ({
  current = false,
  notesUpdatedAt,
  notes = '',
  classes,
  index,
}) => {
  return (
    <div
      className={classNames(
        classes.root,
        current ? classes.current : classes.previous,
      )}
    >
      {current ? (
        <Typography className={classes.status} variant="body1">
          Current
        </Typography>
      ) : (
        <React.Fragment>
          <Typography className={classes.status} variant="body1">
            Previous
          </Typography>
          <Typography className={classes.timeStamp} variant="body1">
            {notesUpdatedAt}
          </Typography>
        </React.Fragment>
      )}
      <Typography
        className={classes.content}
        variant="body1"
        data-test-id={`SavedDealNote-notes-${index}`}
      >
        {notes}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(SavedDealNote);
